import React, { useState } from 'react'
import { Link } from 'react-router-dom'
import { useAuth, useProtectedPage } from '../../../context/AuthContext'

import DashboardProperties from './DashboardProperties/DashboardProperties'
import DashboardSummary from './DashboardSummary/DashboardSummary'
import useCallApi from '../../../hooks/useCallApi'
import TopAffiliate from './TopAffiliate'
import TopCampaign from './TopCampaign'
import moment from 'moment'

export default function AvatarDashboard(props) {
    const [open, setOpen] = useState(false)
    document.title = 'Avatar Dashboard'

    const auth = useAuth()
    useProtectedPage(auth.permissions, 'avatar')



    return (
        <React.Fragment>
            <div className="page-header d-flex align-items-center">
                <h1 className="mb-h1">Avatar Dashboard</h1>
            </div>
            <div className="row">
                <div className="col-md-6">
                    <div className="card">
                        <div className="p-3 d-flex justify-content-between align-items-center">
                            <h1 className="mb-h1 text-success">Active Properties</h1>
                            <div className="d-flex align-items-center">
                                <Link to="/avatar/propertyManager" className="btn btn-sm btn-primary">
                                    Manage Properties
                                </Link>
                                <span className="badge badge-primary ml-2" style={{ cursor: 'pointer' }} onClick={() => setOpen(!open)}>
                                    {open ? '-' : '+'}
                                </span>
                            </div>
                        </div>
                    </div>
                    <div className="py-3">
                        <DashboardProperties status="active" globalOpen={open} globalSetOpen={setOpen} />
                    </div>
                </div>
                <div className="col-md-6">
                    <DashboardSummary showSystemMessage={props.showSystemMessage} />
                    <TopAffiliate title="Top 10 Affiliates By Cost Since Yesterday" type="cost" order="desc" startDate={moment().subtract(1, 'day').startOf('day').format('YYYY-MM-DD')} endDate={moment().format('YYYY-MM-DD')} />
                    <TopAffiliate title="Lowest 10 Affiliates By Margin Since Yesterday" type="margin" order="asc" startDate={moment().subtract(1, 'day').startOf('day').format('YYYY-MM-DD')} endDate={moment().format('YYYY-MM-DD')} />
                    <TopCampaign title="Top 10 Campaigns Since Yesterday" type="network_earnings" order="desc" startDate={moment().subtract(1, 'day').startOf('day').format('YYYY-MM-DD')} endDate={moment().format('YYYY-MM-DD')} />
                </div>
            </div>
        </React.Fragment>
    )
}
